import { useCappsPricingWebApiHandler_getApplicationPaymentRequirement } from '@zg-rentals/ts-capps-client-react-query';

export function useApplicationPaymentRequirement({
  applicationId,
  enabled = true,
}: { applicationId?: string; enabled?: boolean } = {}) {
  const { data, isPending, isError } = useCappsPricingWebApiHandler_getApplicationPaymentRequirement(
    { applicationId: applicationId ?? '' },
    {
      enabled: enabled && !!applicationId,
      meta: {
        tags: ['applicationPaymentRequirement'],
        context: {
          api: 'getApplicationPaymentRequirement',
          details: 'Reads the true-up owed for an application before submit',
        },
      },
    },
  );

  const deltaInCents = data?.deltaInCents ?? 0;

  return {
    deltaInCents,
    requiresTrueUp: deltaInCents > 0,
    isLoading: enabled && !!applicationId && isPending,
    isError,
  };
}
